import React from 'react';
import SignerStep from '../../components/ContractSteps/SignerStep';
import MemberStep from '../../components/ContractSteps/MemberStep';
import PaymentStep from '../../components/ContractSteps/PaymentStep';
import CalculationStep from './steps/CalculationStep';
import AddNewMemberButton from './AddNewMemberButton';
import OncoCarePassportIdInfo from './OncoCarePassportIdInfo';

import ProfileIcon from '../../icons/Profile';
import GlobeIcon from '../../icons/Globe';
import CalculatorIcon from '../../icons/Calculator';
import CardIcon from '../../icons/Card';

export const stepsId = {
  signer: 'signer',
  insuredPerson: 'insuredPerson',
  calculator: 'calculator',
  payment: 'payment',
  confirmation: 'confirmation',
};

export default [
  {
    n: 1,
    iconName: '',
    icon: <ProfileIcon />,
    id: stepsId.signer,
    label: 'contract.steps.signer',
    content: (data) => {
      const props = data;
      props.params.hasLanguageSensitiveNames = true;
      props.params.hasAddressInputsLanguageSensitiveNames = true;

      return <SignerStep {...props} />;
    },
  },
  {
    n: 2,
    iconName: '',
    icon: <GlobeIcon />,
    id: stepsId.insuredPerson,
    label: 'contract.steps.insuredPerson',
    content: (data) => {
      const props = data;
      props.params.hasLanguageSensitiveNames = true;
      props.params.hasAddressInputsLanguageSensitiveNames = true;
      props.params.disabledHasAddedSigner = true;

      props.params.handleResolveSpecificData = (setValue, member) => {
        setValue('isChild', member.isChild);
        setValue('isPerson', member.isPerson);
        setValue('isParent', member.isParent);
      };
      return (
        <MemberStep
          {...props}
          addNewMemberButtonComponent={<AddNewMemberButton {...props} />}
          passportIdInfoComponent={<OncoCarePassportIdInfo {...props} />}
        />
      );
    },
  },
  {
    n: 3,
    iconName: '',
    icon: <CalculatorIcon />,
    id: stepsId.calculator,
    label: 'contract.steps.calculator',
    content: CalculationStep,
  },
  {
    n: 4,
    iconName: '',
    icon: <CardIcon />,
    id: stepsId.payment,
    label: 'contract.steps.payment',
    content: PaymentStep,
  },
  {
    n: 5,
    iconName: 'checkmark',
    icon: null,
    id: stepsId.confirmation,
    label: 'contract.steps.confirmation',
    content: () => <></>,
  },
];
